import { cn, NoddiIcon } from 'noddi-ui-common';
import { CustomDateFormats, noddiFormatDate } from 'noddi-util';
import { Button } from '../../../../base/button/button';
import { HidePastDaysToggle } from '../HidePastDaysToggle/HidePastDaysToggle';
import { MonthCalendarNavigatorProps } from './types';

/**
 * Month stepper shared by MonthCalendar and month grids that draw their own days, so every month
 * calendar steps, jumps to today and hides past days the same way — YearNavigator's counterpart.
 * The past-days toggle sits beside Today, both being about where the calendar starts.
 */
export const MonthCalendarNavigator = ({
  currentDate,
  onMonthChange,
  todayLabel = 'Today',
  hidePastDays,
  onHidePastDaysChange,
  headerActions,
  className
}: MonthCalendarNavigatorProps) => {
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      <Button
        variant='outline'
        size='sm'
        onClick={() => onMonthChange(new Date(year, month - 1, 1))}
        aria-label='Previous month'
      >
        <NoddiIcon name='ChevronLeft' />
      </Button>
      <h2 className='min-w-35 text-center text-lg font-semibold capitalize sm:min-w-50 sm:text-xl'>
        {noddiFormatDate(currentDate, CustomDateFormats.FULL_MONTH)} {year}
      </h2>
      <Button
        variant='outline'
        size='sm'
        onClick={() => onMonthChange(new Date(year, month + 1, 1))}
        aria-label='Next month'
      >
        <NoddiIcon name='ChevronRight' />
      </Button>
      <Button variant='outline' size='sm' onClick={() => onMonthChange(new Date())}>
        {todayLabel}
      </Button>
      {onHidePastDaysChange && (
        <HidePastDaysToggle hidePastDays={hidePastDays ?? false} onChange={onHidePastDaysChange} />
      )}
      {headerActions && <div className='ml-auto flex items-center gap-2'>{headerActions}</div>}
    </div>
  );
};
